import { makeActiveNumber } from "./ActiveNumberHolder";

const activeNumbers = (savedObject, openObject) => {
  return [
    makeActiveNumber(
      "/icons/icon_checkmark.png",
      "completed",
      savedObject?.completed
    ),
    makeActiveNumber(
      "/icons/icon_active.png",
      "In Active",
      savedObject?.putInActive
    ),
    makeActiveNumber(
      "/icons/icon_image.png",
      "Images",
      openObject?.images.length
    ),
    makeActiveNumber(
      "/icons/icon_report.png",
      "Reports",
      openObject?.reports.length
    ),
    makeActiveNumber(
      "/icons/icon_thought.png",
      "Thoughts",
      openObject?.thoughts.length
    ),
    makeActiveNumber(
      "/icons/icon_statement.png",
      "Statements",
      openObject?.statements.length
    ),
  ];
};

export default activeNumbers;
